import { useMemo } from 'react';
import {
  type GroupedPermissions,
  type UseFilteredPermissionMatrixParams,
  type UseFilteredPermissionMatrixResult,
} from './types';

export const useFilteredPermissionMatrix = ({
  filterNonFieldLevelPermission,
  filterFieldLevelPermission,
  manualSearch,
  allFieldValues,
}: UseFilteredPermissionMatrixParams): UseFilteredPermissionMatrixResult => {
  const filteredData = useMemo(() => {
    return Object.entries(filterNonFieldLevelPermission).reduce<GroupedPermissions>(
      (acc, [key, value]) => {
        const filteredItems = value.filter((item) =>
          item?.displayName?.toLowerCase().includes(manualSearch?.toLowerCase())
        );

        if (filteredItems.length > 0) {
          acc[key] = filteredItems;
        }
        return acc;
      },
      {}
    );
  }, [filterNonFieldLevelPermission, manualSearch]);

  const filteredFieldLevelData = useMemo(() => {
    return Object.entries(filterFieldLevelPermission).reduce<GroupedPermissions>(
      (acc, [key, value]) => {
        const filteredItems = value.filter((item) =>
          allFieldValues[item?.key]?.toLowerCase().includes(manualSearch?.toLowerCase())
        );
        if (filteredItems.length > 0) {
          acc[key] = filteredItems;
        }
        return acc;
      },
      {}
    );
  }, [filterFieldLevelPermission, manualSearch, allFieldValues]);

  return { filteredData, filteredFieldLevelData };
};

export default useFilteredPermissionMatrix;
